import Money from '../dto/Money';

export default class FeeTableValue {

    static clone(feeTableValueToClone) {

        let feeTableValue = new FeeTableValue();
        feeTableValue.id = null;
        feeTableValue.income = feeTableValueToClone.income;
        feeTableValue.dailyHours = feeTableValueToClone.dailyHours;
        feeTableValue.chargeLevel1 = feeTableValueToClone.chargeLevel1;
        feeTableValue.chargeLevel2 = feeTableValueToClone.chargeLevel2;
        feeTableValue.chargeLevel3 = feeTableValueToClone.chargeLevel3;
        feeTableValue.chargeLevel4 = feeTableValueToClone.chargeLevel4;
        feeTableValue.chargeLevel5 = feeTableValueToClone.chargeLevel5;
        feeTableValue.deleted = false

        return feeTableValue;
    }

    static init(currency) {
        let feeTableValue = new FeeTableValue();
        feeTableValue.id = null;
        feeTableValue.income = {
            min: Money.fromNumber(0, currency),
            max: null
        };
        feeTableValue.dailyHours = {min: 0, max: 24};
        feeTableValue.chargeLevel1 = Money.fromNumber(0, currency);
        feeTableValue.chargeLevel2 = Money.fromNumber(0, currency);
        feeTableValue.chargeLevel3 = Money.fromNumber(0, currency);
        feeTableValue.chargeLevel4 = Money.fromNumber(0, currency);
        feeTableValue.chargeLevel5 = Money.fromNumber(0, currency);
        feeTableValue.deleted = false

        return feeTableValue;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let feeTableValue = new FeeTableValue();
        feeTableValue.id = data.id;

        feeTableValue.income = {
            min: Money.fromData(data.income.min),
            max: null != data.income.max ? Money.fromData(data.income.max) : null,
        };
        feeTableValue.dailyHours = {
            min: data.dailyHours.min,
            max: data.dailyHours.max,
        };
        feeTableValue.chargeLevel1 = Money.fromData(data.chargeLevel1);
        feeTableValue.chargeLevel2 = Money.fromData(data.chargeLevel2);
        feeTableValue.chargeLevel3 = Money.fromData(data.chargeLevel3);
        feeTableValue.chargeLevel4 = Money.fromData(data.chargeLevel4);
        feeTableValue.chargeLevel5 = Money.fromData(data.chargeLevel5);
        feeTableValue.deleted = false;

        return feeTableValue;
    }

    static toData(entry) {
        let income = {
            min: Money.toData(entry.income.min),
            max: null !== entry.income.max && '' !== entry.income.max ? Money.toData(entry.income.max) : null,
        };
        return {
            id: entry.id,
            income: income,
            dailyHours: entry.dailyHours,
            chargeLevel1: Money.toData(entry.chargeLevel1),
            chargeLevel2: Money.toData(entry.chargeLevel2),
            chargeLevel3: Money.toData(entry.chargeLevel3),
            chargeLevel4: Money.toData(entry.chargeLevel4),
            chargeLevel5: Money.toData(entry.chargeLevel5),
            deleted: entry.deleted
        }
    }
}
